import { OfflineOrderLoadListParams, OnlineOrderLoadListParams } from '@order/const';
import { OrderHistoryList, StateUtils } from '@spartacus/core';
import { ORDERS_LIST } from '../order-state';

export const ORDERS_LIST_LOAD = '[Order] Orders List Load';
export const OFFLINE_ORDERS_LIST_LOAD = '[Order] Offline Orders List Load';
export const ORDERS_LIST_LOAD_FAIL = '[Order] Orders List Load Fail';
export const ORDERS_LIST_LOAD_SUCCESS = '[Order] Orders List Load Success';
export const ORDERS_LIST_CLEAR = '[Order] Orders List Clear';

export class OrdersListLoad extends StateUtils.LoaderLoadAction {
  readonly type = ORDERS_LIST_LOAD;

  constructor(public payload: OnlineOrderLoadListParams) {
    super(ORDERS_LIST);
  }
}

export class OfflineOrdersListLoad extends StateUtils.LoaderLoadAction {
  readonly type = OFFLINE_ORDERS_LIST_LOAD;

  constructor(public payload: OfflineOrderLoadListParams) {
    super(ORDERS_LIST);
  }
}

export class OrdersListLoadFail extends StateUtils.LoaderFailAction {
  readonly type = ORDERS_LIST_LOAD_FAIL;

  constructor(public payload: unknown) {
    super(ORDERS_LIST, payload);
  }
}

export class OrdersListLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = ORDERS_LIST_LOAD_SUCCESS;

  constructor(public payload: OrderHistoryList) {
    super(ORDERS_LIST);
  }
}

export class OnlineOrdersListClear extends StateUtils.LoaderResetAction {
  readonly type = ORDERS_LIST_CLEAR;

  constructor() {
    super(ORDERS_LIST);
  }
}

export type OnlineOrdersListActions =
  | OrdersListLoad
  | OrdersListLoadFail
  | OrdersListLoadSuccess
  | OnlineOrdersListClear;
